var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1677_38971)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1677_38971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.639 11.1995L20.2274 7.41794C20.2325 7.39207 20.2377 7.36621 20.2428 7.33517V2.38967C20.2377 2.0948 20.0058 1.85684 19.712 1.84649H17.2485C16.965 1.84649 16.7331 2.09997 16.7331 2.38967V4.43822L13.2027 1.41712C13.012 1.25158 12.7286 1.25158 12.5327 1.41712L1.09641 11.1943C0.874796 11.3754 0.849027 11.7013 1.02941 11.9237C1.20979 12.1462 1.53448 12.172 1.7561 11.991C1.76125 11.9858 1.76125 11.9858 1.76641 11.9806L12.8677 2.49313L16.8413 5.89187L19.2172 7.91973L23.9742 11.9858C24.1906 12.172 24.5153 12.1462 24.7009 11.9289C24.8813 11.7116 24.8555 11.3857 24.639 11.1995ZM19.2069 6.54368L17.7638 5.32283V2.88629H19.2069V6.54368Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3671 12.2438L20.9189 11.0023L13.2036 4.38587C13.0129 4.22033 12.7295 4.22033 12.5336 4.38587L4.81835 11.0023L3.37013 12.2438C3.15367 12.4301 3.1279 12.756 3.31344 12.9732C3.49382 13.1905 3.81336 13.2164 4.02467 13.0353L4.02982 13.0302L4.67405 12.4715V22.171C4.6792 22.4607 4.91628 22.6987 5.20489 22.7039H20.5272C20.8158 22.6987 21.0529 22.4659 21.058 22.171V12.4715L21.7022 13.0302C21.795 13.1077 21.9084 13.1543 22.0321 13.1543C22.1816 13.1543 22.3259 13.0871 22.4238 12.9732C22.6145 12.7508 22.5835 12.4249 22.3671 12.2438ZM14.9301 21.6641H10.8071V16.0771H14.9301V21.6641ZM15.9609 21.6641V15.5753C15.9609 15.2908 15.7496 15.0425 15.4661 15.0425H10.2711C9.98763 15.0425 9.77632 15.2908 9.77632 15.5753V21.6641H5.70481V11.5869L12.8686 5.46188L20.0324 11.5869V21.6641H15.9609Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1677_38971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9104,
    height: 24,
    transform: "translate(0.910156)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1677_38971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9104,
    height: 24,
    transform: "translate(0.910156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.4b56d6479f9a00f0f3b9b61dfa72aed7.svg";
export { ForwardRef as ReactComponent };